<template>
    <el-form-item label="Select Employee" label-position="top">
        <treeselect v-model="value" :multiple="true" :options="options" />
    </el-form-item>
</template>

<script setup>
    import { ref, watch, onMounted } from 'vue'
    import Treeselect from 'vue3-treeselect'
    import 'vue3-treeselect/dist/vue3-treeselect.css'
    // import axios from '@/utils/apiClient'
    import axios from '@/utils/apiClient'

    const value = ref([])
    const options = ref([])

    // Define emits
    const emit = defineEmits(['update:modelValue'])

    // Watch for changes in selectedEmployees and emit the value
    watch(value, newValue => {
        emit('update:modelValue', newValue)
    })

    onMounted(() => {
        axios.get('Employee/ByDepartment').then(response => {
            options.value = response.data
        })
    })
</script>
